<template>
  <div class="container-fluid">
    <div class="row bg-primary text-bg-primary pt-2 pb-2 d-print-none">
      <div class="col text-start font-weight-bold" v-if="!isMobile()">{{ poster.presentation_code }}
        <span v-html="poster.title"></span>
      </div>
      <div class="col text-start smaller" v-else>{{ poster.presentation_code }} <span
        v-html="poster.title"></span></div>
    </div>
    <div class="row bg-primary text-bg-primary font-weight-bold mb-2 d-print-none">
      <div class="col d-flex ">
        <router-link :to="getBackUrl()" class="btn text-bg-primary btn-sm mr-auto my-auto">
          <icon :icon="['fal', 'square-list']" class="fa-3x"/>
          <div class="my-auto">{{ _.poster_nav_overview }}</div>
        </router-link>
        <router-link class="btn text-bg-primary btn-sm" :to="'/viewer/' + poster.abstract_id"
                     title="Switch to abstract">
          <icon :icon="['fal', 'file-pdf']" class="fa-3x"/>
          <div class="my-auto">{{ _.poster_nav_back_presentation }}</div>
        </router-link>
        <router-link class="btn text-bg-primary btn-sm" :to="'/viewer/abstract/' + poster.abstract_id"
                     title="Switch to abstract" v-if="setting.abstract === true">
          <icon :icon="['fab', 'wpforms']" class="fa-3x"/>
          <div class="my-auto">{{ _.poster_nav_abstract }}</div>
        </router-link>
        <!--        <router-link class="btn btn-sm text-bg-primary" :to="'/viewer/video/' + poster.abstract_id + '/videoid/1'"-->
        <!--                     v-if="poster.content.video1"-->
        <!--                     title="Switch to abstract">-->
        <!--          <icon :icon="['fal', 'film']" class="fa-3x"/>-->
        <!--          <div class="my-auto">{{ _.card_video }} 1</div>-->
        <!--        </router-link>-->
        <!--        <router-link class="btn btn-sm text-bg-primary" :to="'/viewer/video/' + poster.abstract_id + '/videoid/2'"-->
        <!--                     v-if="poster.content.video2 "-->
        <!--                     title="Switch to abstract">-->
        <!--          <icon :icon="['fal', 'film']" class="fa-3x"/>-->
        <!--          <div class="my-auto">{{ _.card_video }} 2</div>-->
        <!--        </router-link>-->
        <!--        <router-link class="btn btn-sm text-bg-primary" :to="'/viewer/video/' + poster.abstract_id + '/videoid/3'"-->
        <!--                     v-if="poster.content.video3"-->
        <!--                     title="Switch to abstract">-->
        <!--          <icon :icon="['fal', 'film']" class="fa-3x"/>-->
        <!--          <div class="my-auto">{{ _.card_video }} 3</div>-->
        <!--        </router-link>-->
      </div>
    </div>
    <div class="row" v-if="poster.content && poster.content.video">
      <div class="col d-flex">
        <template v-if="videoCheck === false || (videoCheck=== true && videoPlay === true)">
          <div class="mx-auto stream-container " v-if="videoLink && videoLink.length > 0">
            <div class="stream">
              <iframe
                :src="videoLink" style="position:absolute;width:90%;height:90%;" frameborder="0"
                allow="autoplay; fullscreen" allowfullscreen></iframe>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else>
      <loader></loader>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import Loader from "../components/Loader";
import pdfvuer from "pdfvuer";

export default {
  name: "ViewerVideo",
  components: {Loader},
  computed: {
    ...mapGetters({
      poster: 'poster'
    }),
    ...mapState([
      'presentationSite', "fullscreen", "videoCheck", "setting"
    ])
  },
  data() {
    return {
      videoPlay: false,
      transcoding: false,
      videoLink: ''
    }
  },
  methods: {
    ...mapActions({
      getPosterById: 'getPosterById',
    }),
    ...mapActions('vimeo', ['GET_VIDEOLINK']),
    async getPdf() {
      this.$store.commit('setPoster', {});
      this.getPosterById(this.$route.params.id).then((response) => {
        this.$store.commit('setPoster', response.data);
        if (response.data.content.video) {
          this.requestDownloadLink(response.data.content.video)
        }
      }).catch((error) => {
      })
    },
    async requestDownloadLink(id) {
      this.GET_VIDEOLINK(id).then((response) => {
        if (response.status === 200) {
          if (response.data.status === 'transcoding') {
            this.transcoding = true;
            return;
          }
          this.videoLink = response.data.player_embed_url;
        }
      });
    },
    getClasses() {
      let code = 'col col-xl-7 offset-xl-2 col-md-9 offset-md-1 border';
      if (this.$store.state.fullscreen === true) {
        code = 'col col-xl-10 offset-xl-1 col-md-10 offset-md-1 border';
      }
      return code;
    },
    getBackUrl() {
      return '/view/' + this.$route.params.id;
    },
    toggleFullscreen() {
      this.$store.state.fullscreen = !this.$store.state.fullscreen;
    },
    getId() {
      return this.$youtube.getIdFromUrl(this.$store.state.poster.content.video);
    },
    error: function (err) {
    },
    getUrl(url) {
      if (!url && url.startsWith('http')) {
        return url;
      }
      return process.env.VUE_APP_PATH_S3URL + url;
    }
  },
  mounted() {
    this.$store.state.fullscreen = true;
  },
  created() {
    this.$store.dispatch('TRACK_ACTION', {
      'value': this.$route.params.id,
      'action': 'viewer/video',
      'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
    });
    this.getPdf();
  }
}
</script>

<style type="text/css" scoped>
.stream-container {
    width: 100%;

    .stream {
        position: relative;
        width: 100%;
        aspect-ratio: 16/9;

        .info-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 3px dashed grey;

            .info {
                flex: 0 0 400px;
                font-size: 2rem;
                line-height: 2.2rem;
                color: grey;
                font-weight: bold;
            }
        }
    }
}

</style>

<style scoped>

</style>
